type InputChangeHandler = React.ChangeEventHandler<HTMLInputElement>;
type InputChangeHandlerBuilder = (
    onChange: InputChangeHandler,
    message?: string
) => InputChangeHandler;
export const blockLeadingSpaces: InputChangeHandlerBuilder = (
    onChange,
    message = 'Value may not begin with spaces'
) => (event) => {
    if (/^\s+/.test(event.target.value)) {
        event.target.setCustomValidity(message);
        event.target.reportValidity();
        event.target.value = '';
        return onChange(event);
    }
    event.target.setCustomValidity('');
    return onChange(event);
};
